<div *ngIf="svg$ | async as svg" [class]="classes" [innerHTML]="svg"></div>
